//export const Base_Url = "https://colibri.az"
//export const Base_Url = "http://localhost:8000"
const hostname = window.location.hostname;

export const Base_Url = 
  hostname === 'localhost' || hostname === '127.0.0.1'
    ? "http://localhost:8000"
    : hostname === 'dev.colibri.az'
      ? "https://dev.colibri.az"
      : "https://colibri.az";